import { ForgeSection, Id } from "@supernova-studio/model";
import z from "zod";
const AfterSectionId = z.string().uuid().nullish().optional();
export const DTOForgeSection = ForgeSection;
export const DTOForgeSectionCreateInput = DTOForgeSection.pick({
    id: true,
    name: true,
    childType: true,
}).extend({
    afterSectionId: AfterSectionId,
});
export const DTOForgeSectionUpdateInput = DTOForgeSection.pick({
    id: true,
    name: true,
});
export const DTOForgeSectionDeleteInput = DTOForgeSection.pick({
    id: true,
}).extend({
    deleteChildren: z.boolean().default(false),
});
export const DTOForgeSectionMoveInput = DTOForgeSection.pick({
    id: true,
}).extend({
    afterSectionId: AfterSectionId,
});
export const DTOForgeSectionItemMoveInput = z.object({
    id: Id,
    sectionId: Id.nullish().optional(), // undefined=stay, null=no section, string=move to section
    afterId: Id.nullish().optional(), // undefined=end, null=beginning, string=after artifact
});
